import { api } from "../../../services/core/api";

/**
 * Ссылка на портал заявок для пользователя.
 * Не влияет на API-маршрут создания заявки.
 */
export const SUPPORT_PORTAL_URL = import.meta.env.VITE_SUPPORT_PORTAL_URL ?? "";

export const SUPPORT_CATEGORY_ID = "7497d701-cf40-4039-be43-5b326005360e";
export const SUPPORT_TEMPLATE_ID = "22f6bf05-acad-437d-af96-3f2d4f7179cd";

export const SUBCATEGORIES = [
  { id: "ca894a86-bc32-405f-89ec-35c8f9df6104", label: "Ошибка" },
  { id: "8266204b-f283-4557-8734-bb056c29a34c", label: "Доработка" },
  {
    id: "f5cfe35b-63b1-4e92-bda8-f8e3f5a47cc3",
    label: "Консультация/Обучение",
  },
  {
    id: "cf0b6034-238f-4dff-9513-83f4bcb6ff43",
    label: "Услуга/Администрирование",
  },
] as const;

/** Идентификаторы подкатегорий — единственный источник правды для всех справочников UI. */
export type SubcategoryId = (typeof SUBCATEGORIES)[number]["id"];

export interface TicketAttachment {
  filename: string;
  base64Data: string;
  size: number;
  mimeType: string;
}

export interface CreateTicketPayload {
  title: string;
  description: string;
  categoryId: string;
  subcategoryId: string;
  createdByEmail: string;
  attachments?: TicketAttachment[];
}

interface CreateTicketRequestBody {
  title: string;
  categoryId: string;
  subcategoryId: string;
  templateId: string;
  data: {
    description: string;
  };
  createdByEmail: string;
  attachments?: TicketAttachment[];
}

function generateIdempotencyKey(): string {
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
  ) {
    return crypto.randomUUID();
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export async function createSupportTicket(
  payload: CreateTicketPayload,
): Promise<{ id: string }> {
  const body: CreateTicketRequestBody = {
    title: payload.title,
    categoryId: payload.categoryId,
    subcategoryId: payload.subcategoryId,
    templateId: SUPPORT_TEMPLATE_ID,
    data: {
      description: payload.description,
    },
    createdByEmail: payload.createdByEmail,
    ...(payload.attachments?.length ? { attachments: payload.attachments } : {}),
  };

  return api.post<{ id: string }, CreateTicketRequestBody>("/support/tickets", body, {
    headers: {
      "Idempotency-Key": generateIdempotencyKey(),
    },
  });
}
